import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing }) => ({
  iconButtonRoot: {
    position: 'absolute',
    right: spacing(2.25)
  },
  iconRoot: {
    width: spacing(2.5),
    height: spacing(2.5),
  }
}));
